import React from 'react';
import {Button} from '../controls/controls.jsx';
import {EmptyState} from '../display/display.jsx';
import {InlineAlert} from '../feedback/feedback.jsx';
import './state-blocks.css';
const classes=(...values)=>values.filter(Boolean).join(' ');
/* State blocks (UX plan D4a, 4 Nov 2026): every collection and step shows loading, empty and error the same way.
   Blocks compose src/ui components only; features decide which state applies. */

/** Loading in the shape of the content that is coming. `shape`: list | card | facts | step. */
export function SkeletonBlock({shape='list',count=3,label='Yükleniyor…',className='',...props}){
 const items=Array.from({length:Math.max(1,count)},(_,index)=>index);
 return <div role="status" className={classes('bs-skeleton-block',className)} data-shape={shape} {...props}>
  <span className="bs-feedback-sr-only">{label}</span>
  <div className="bs-skeleton-items" aria-hidden="true">{items.map(index=>shape==='facts'
   ?<div className="bs-skeleton-fact" key={index}><span className="bs-skeleton-bar" data-size="sm"/><span className="bs-skeleton-bar"/></div>
   :shape==='step'
   ?<div className="bs-skeleton-step" key={index}><span className="bs-skeleton-bar" data-size="lg"/><span className="bs-skeleton-bar"/><span className="bs-skeleton-bar" data-size="sm"/></div>
   :<div className="bs-skeleton-row" data-card={shape==='card'?'true':undefined} key={index}><span className="bs-skeleton-dot"/><span className="bs-skeleton-lines"><span className="bs-skeleton-bar" data-size="sm"/><span className="bs-skeleton-bar"/><span className="bs-skeleton-bar" data-size="md"/></span></div>)}</div>
 </div>;
}

const EMPTY_VARIANT={first:'no-records',search:'search',waiting:'waiting'};
/** What happened, why, and the next step. `variant`: first (first run, may carry the page's primary action) | search | waiting. */
export function EmptyBlock({title,reason,action,variant='first',icon,compact=false,className=''}){
 const button=action&&<Button intent={variant==='first'?'primary':'secondary'} disabled={action.disabled} onClick={action.onClick}>{action.label}</Button>;
 return <EmptyState className={classes('bs-empty-block',className)} variant={EMPTY_VARIANT[variant]||'no-records'} compact={compact} title={title} icon={icon} action={button||undefined}>{reason}</EmptyState>;
}

/** A page-level error with one way forward. Field errors stay in Field. */
export function ErrorBlock({message,onRetry,retryLabel='Yeniden dene',className=''}){
 if(!message)return null;
 return <div className={classes('bs-error-block',className)}><InlineAlert tone="danger">{message}</InlineAlert>{onRetry&&<Button intent="secondary" size="sm" onClick={onRetry}>{retryLabel}</Button>}</div>;
}
